'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _toConsumableArray2 = require('babel-runtime/helpers/toConsumableArray');

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _lodash = require('lodash');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var FavoriteReportsController = function () {
  function FavoriteReportsController(authService, reportingService, loadingService, $state) {
    "ngInject";

    (0, _classCallCheck3.default)(this, FavoriteReportsController);
    this.authService = authService;
    this.reportingService = reportingService;
    this.loadingService = loadingService;
    this.$state = $state;

    this.loadReports();
    this.allReports = [];
    this.favReports = [];
    this.selAllReports = [];
    this.selFavReports = [];
  }

  (0, _createClass3.default)(FavoriteReportsController, [{
    key: 'loadReports',
    value: function loadReports() {
      var _this = this;

      this.loadingService.showLoading('favReports', 'Loading Reports ...');

      this.reportingService.getFavoriteReports(this.authService.authData.currentLocation.key).then(function (response) {
        _this.allReports = response.data.allReports;
        _this.favReports = response.data.favoriteReports;

        _this.sortReports();
      }).catch(function (err) {}).finally(function () {
        _this.loadingService.hideLoading('favReports');
      });
    }
  }, {
    key: 'sortReports',
    value: function sortReports() {
      this.allReports = (0, _lodash.sortBy)(this.allReports, 'name');
      this.favReports = (0, _lodash.sortBy)(this.favReports, 'name');
    }
  }, {
    key: 'selectReports',
    value: function selectReports() {
      var _favReports;

      var selReportIds = this.selAllReports.map(function (r) {
        return r.reportId;
      });
      var selReportItems = (0, _lodash.filter)(this.allReports, function (o) {
        return (0, _lodash.find)(selReportIds, function (repId) {
          return o.reportId === repId;
        });
      });
      this.allReports = _lodash.without.apply(undefined, [this.allReports].concat((0, _toConsumableArray3.default)(selReportItems)));
      (_favReports = this.favReports).push.apply(_favReports, (0, _toConsumableArray3.default)(selReportItems));
      this.selAllReports = [];

      this.sortReports();
    }
  }, {
    key: 'deselectReports',
    value: function deselectReports() {
      var _allReports;

      var selReportIds = this.selFavReports.map(function (r) {
        return r.reportId;
      });
      var selReportItems = (0, _lodash.filter)(this.favReports, function (o) {
        return (0, _lodash.find)(selReportIds, function (repId) {
          return o.reportId === repId;
        });
      });
      this.favReports = _lodash.without.apply(undefined, [this.favReports].concat((0, _toConsumableArray3.default)(selReportItems)));
      (_allReports = this.allReports).push.apply(_allReports, (0, _toConsumableArray3.default)(selReportItems));
      this.selFavReports = [];

      this.sortReports();
    }
  }, {
    key: 'saveChanges',
    value: function saveChanges() {
      var _this2 = this;

      this.loadingService.showLoading('favReports', 'Saving Changes ...');

      var favReportIds = this.favReports.map(function (r) {
        return r.reportId;
      });

      this.reportingService.updateFavoriteReports(this.authService.authData.currentLocation.key, favReportIds).then(function (response) {
        _this2.$state.go('reportsLanding');
      }).catch(function (err) {}).finally(function () {
        _this2.loadingService.hideLoading('favReports');
      });
    }
  }]);
  return FavoriteReportsController;
}();

exports.default = FavoriteReportsController;


// WEBPACK FOOTER //
// ./client/app/components/reports/favoriteReports/favoriteReports.controller.js